import React from 'react';

const IconFacebook = () => (
  <svg xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24">
    <title>Facebook</title>
    <path
      d="M12 2.25C6.486 2.25 2.25 6.486 2.25 12c0 4.914 3.594 8.961 8.25 9.75V15.75H7.688V12H10.5V9.375c0-2.625 1.563-4.125 3.938-4.125 1.125 0 2.438.188 2.438.188v2.813h-1.375c-1.344 0-1.813.844-1.813 1.719V12h3.094l-.5 3.75h-2.594V21C18.406 20.961 21.75 16.914 21.75 12c0-5.514-4.236-9.75-9.75-9.75z"
    />
  </svg>
);

export default IconFacebook;
